__turbopack_context__.v({
  "archFlow": "ProjectShowcase-module-scss-module__MOG1qW__archFlow",
  "archStep": "ProjectShowcase-module-scss-module__MOG1qW__archStep",
  "archStepBody": "ProjectShowcase-module-scss-module__MOG1qW__archStepBody",
  "archStepDescription": "ProjectShowcase-module-scss-module__MOG1qW__archStepDescription",
  "archStepNumber": "ProjectShowcase-module-scss-module__MOG1qW__archStepNumber",
  "archStepTitle": "ProjectShowcase-module-scss-module__MOG1qW__archStepTitle",
  "archived": "ProjectShowcase-module-scss-module__MOG1qW__archived",
  "badgeRow": "ProjectShowcase-module-scss-module__MOG1qW__badgeRow",
  "badges": "ProjectShowcase-module-scss-module__MOG1qW__badges",
  "categoryHeader": "ProjectShowcase-module-scss-module__MOG1qW__categoryHeader",
  "categoryIcon": "ProjectShowcase-module-scss-module__MOG1qW__categoryIcon",
  "categoryLabel": "ProjectShowcase-module-scss-module__MOG1qW__categoryLabel",
  "chipIcon": "ProjectShowcase-module-scss-module__MOG1qW__chipIcon",
  "ctaBtn": "ProjectShowcase-module-scss-module__MOG1qW__ctaBtn",
  "ctaRow": "ProjectShowcase-module-scss-module__MOG1qW__ctaRow",
  "ctaTrust": "ProjectShowcase-module-scss-module__MOG1qW__ctaTrust",
  "ctaWrap": "ProjectShowcase-module-scss-module__MOG1qW__ctaWrap",
  "decisionAccordion": "ProjectShowcase-module-scss-module__MOG1qW__decisionAccordion",
  "decisionChip": "ProjectShowcase-module-scss-module__MOG1qW__decisionChip",
  "decisionChipChallenge": "ProjectShowcase-module-scss-module__MOG1qW__decisionChipChallenge",
  "decisionDetails": "ProjectShowcase-module-scss-module__MOG1qW__decisionDetails",
  "decisionExpand": "ProjectShowcase-module-scss-module__MOG1qW__decisionExpand",
  "decisionItem": "ProjectShowcase-module-scss-module__MOG1qW__decisionItem",
  "decisionItemBody": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemBody",
  "decisionItemIcon": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemIcon",
  "decisionItemIconChallenge": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemIconChallenge",
  "decisionItemIconSolution": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemIconSolution",
  "decisionItemIconTradeoff": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemIconTradeoff",
  "decisionItemLabel": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemLabel",
  "decisionItemLabelChallenge": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemLabelChallenge",
  "decisionItemLabelSolution": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemLabelSolution",
  "decisionItemLabelTradeoff": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemLabelTradeoff",
  "decisionItemText": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemText",
  "decisionItemTextMuted": "ProjectShowcase-module-scss-module__MOG1qW__decisionItemTextMuted",
  "decisionShort": "ProjectShowcase-module-scss-module__MOG1qW__decisionShort",
  "decisionSummary": "ProjectShowcase-module-scss-module__MOG1qW__decisionSummary",
  "decisionSummaryContent": "ProjectShowcase-module-scss-module__MOG1qW__decisionSummaryContent",
  "decisionsContainer": "ProjectShowcase-module-scss-module__MOG1qW__decisionsContainer",
  "description": "ProjectShowcase-module-scss-module__MOG1qW__description",
  "descriptionEm": "ProjectShowcase-module-scss-module__MOG1qW__descriptionEm",
  "featureCard": "ProjectShowcase-module-scss-module__MOG1qW__featureCard",
  "featureContent": "ProjectShowcase-module-scss-module__MOG1qW__featureContent",
  "featureDescription": "ProjectShowcase-module-scss-module__MOG1qW__featureDescription",
  "featureIcon": "ProjectShowcase-module-scss-module__MOG1qW__featureIcon",
  "featureLabel": "ProjectShowcase-module-scss-module__MOG1qW__featureLabel",
  "featuresGrid": "ProjectShowcase-module-scss-module__MOG1qW__featuresGrid",
  "hero": "ProjectShowcase-module-scss-module__MOG1qW__hero",
  "heroBody": "ProjectShowcase-module-scss-module__MOG1qW__heroBody",
  "heroHeader": "ProjectShowcase-module-scss-module__MOG1qW__heroHeader",
  "heroLeft": "ProjectShowcase-module-scss-module__MOG1qW__heroLeft",
  "heroRight": "ProjectShowcase-module-scss-module__MOG1qW__heroRight",
  "highlightBody": "ProjectShowcase-module-scss-module__MOG1qW__highlightBody",
  "highlightCard": "ProjectShowcase-module-scss-module__MOG1qW__highlightCard",
  "highlightDescription": "ProjectShowcase-module-scss-module__MOG1qW__highlightDescription",
  "highlightNumber": "ProjectShowcase-module-scss-module__MOG1qW__highlightNumber",
  "highlightTitle": "ProjectShowcase-module-scss-module__MOG1qW__highlightTitle",
  "highlightsGrid": "ProjectShowcase-module-scss-module__MOG1qW__highlightsGrid",
  "inDev": "ProjectShowcase-module-scss-module__MOG1qW__inDev",
  "keyProp": "ProjectShowcase-module-scss-module__MOG1qW__keyProp",
  "keyProps": "ProjectShowcase-module-scss-module__MOG1qW__keyProps",
  "live": "ProjectShowcase-module-scss-module__MOG1qW__live",
  "logo": "ProjectShowcase-module-scss-module__MOG1qW__logo",
  "logoDark": "ProjectShowcase-module-scss-module__MOG1qW__logoDark",
  "logoLight": "ProjectShowcase-module-scss-module__MOG1qW__logoLight",
  "logoWrap": "ProjectShowcase-module-scss-module__MOG1qW__logoWrap",
  "openSourceChip": "ProjectShowcase-module-scss-module__MOG1qW__openSourceChip",
  "panel": "ProjectShowcase-module-scss-module__MOG1qW__panel",
  "panelMuted": "ProjectShowcase-module-scss-module__MOG1qW__panelMuted",
  "panelNumber": "ProjectShowcase-module-scss-module__MOG1qW__panelNumber",
  "panelSubtitle": "ProjectShowcase-module-scss-module__MOG1qW__panelSubtitle",
  "panelTitle": "ProjectShowcase-module-scss-module__MOG1qW__panelTitle",
  "pulseGlow": "ProjectShowcase-module-scss-module__MOG1qW__pulseGlow",
  "showcase": "ProjectShowcase-module-scss-module__MOG1qW__showcase",
  "statBody": "ProjectShowcase-module-scss-module__MOG1qW__statBody",
  "statCard": "ProjectShowcase-module-scss-module__MOG1qW__statCard",
  "statIcon": "ProjectShowcase-module-scss-module__MOG1qW__statIcon",
  "statLabel": "ProjectShowcase-module-scss-module__MOG1qW__statLabel",
  "statValue": "ProjectShowcase-module-scss-module__MOG1qW__statValue",
  "statsGrid": "ProjectShowcase-module-scss-module__MOG1qW__statsGrid",
  "statusChip": "ProjectShowcase-module-scss-module__MOG1qW__statusChip",
  "tagline": "ProjectShowcase-module-scss-module__MOG1qW__tagline",
  "techCategory": "ProjectShowcase-module-scss-module__MOG1qW__techCategory",
  "techGrid": "ProjectShowcase-module-scss-module__MOG1qW__techGrid",
  "title": "ProjectShowcase-module-scss-module__MOG1qW__title",
});
